import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsString,
  IsUUID,
  IsOptional,
  MaxLength,
  Matches,
} from 'class-validator'

/**
 * DTO for creating a new competency
 */
export class CreateCompetencyDto {
  @ApiProperty({
    description: 'Unique code for the competency (e.g., MATH-CALC-DEC)',
    example: 'MATH-CALC-DEC',
    maxLength: 128,
  })
  @IsString()
  @MaxLength(128)
  @Matches(/^[A-Z0-9-_]+$/, {
    message:
      'Code must contain only uppercase letters, numbers, hyphens, and underscores',
  })
  code!: string

  @ApiProperty({
    description: 'Action statement (verb-based)',
    example: 'Calculer avec des nombres décimaux',
    maxLength: 512,
  })
  @IsString()
  @MaxLength(512)
  statement!: string

  @ApiPropertyOptional({
    description: 'Domain or category',
    example: 'Calculer',
    maxLength: 128,
  })
  @IsOptional()
  @IsString()
  @MaxLength(128)
  domain?: string

  @ApiPropertyOptional({
    description: 'Extended description',
    example: 'This competency covers basic decimal arithmetic.',
  })
  @IsOptional()
  @IsString()
  description?: string

  @ApiProperty({
    description: 'Subject UUID this competency belongs to',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsUUID()
  subjectId!: string
}
